export default __webpack_public_path__ + "static/media/Rainmaker_soft_icon_37_User.9f7240b0.svg";